import React from 'react'
import update from 'immutability-helper';
import moment from 'moment'
import NavLink from '../Routes/NavLink'
import DropzoneComponent from 'react-dropzone-component';
import { browserHistory } from 'react-router'

import LeasesSelect from '../Leases/LeaseSelect';
import NumericSelect from '../../helpers/General/NumericSelect'
import UsersSelect from '../Users/UsersSelect'
import BuildingsSelect from '../Buildings/BuildingsSelect'
import SpecificSpacesSelect from '../Spaces/SpecificSpacesSelect'
import InvoiceList from '../Invoices/InvoiceList'

import OrderTypeSelect from '../../helpers/WorkOrders/OrderTypeSelect'
import OrderPrioritySelect from '../../helpers/WorkOrders/OrderPrioritySelect'
import OrderStatusSelect from '../../helpers/WorkOrders/OrderStatusSelect'
import PropertiesSelect from '../Properties/PropertiesSelect.jsx';
import TenantInformationCard from '../../helpers/Cards/TenantInformationCard'

import { workOrder } from '../../core/controllers/WorkOrder';
import { modal } from '../../core/utilities/modal';
import { documents } from '../../core/controllers/Documents';
import { user } from '../../core/controllers/user';
import { dropZone } from '../../core/utilities/DropZoneHandler';
import { generatePDF } from '../../helpers/General/GeneratePDF';
import { property } from '../../core/controllers/Property'
import { TabGroup } from '../../helpers/Tabs/TabGroup';
import { Tab } from '../../helpers/Tabs/Tab';

// #  TODO move this to seperate component
const Attachment = ({attachment, deleteFunc}) => {
    return (
        <attachment key={attachment.id}>
            <div class={attachment.content_type == 'pdf' ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xs-12" : "col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6"}>
                <span class="deleteDocument" onClick={deleteFunc.bind(this, attachment)}><i class="pe-7s-close"></i></span>
                <a href={attachment.url} target="_blank">
                    { attachment.content_type == 'pdf' ? (
                        <object width="100%" height="500" data={attachment.url} type="application/pdf"></object>
                    ) : (
                        <img src={attachment.url} width="100px" height="100px" />
                    )}
                </a>
            </div>
        </attachment>
    );
};

export default class WorkOrderEdit extends React.Component {
    constructor(props) {
        super(props);
        var self = this;
        var newOrder = false;

        if(props.workOrderID == 'new') {
            newOrder = true;
        }

        this.state = {
            orderID : props.workOrderID,
            orderData: {
                work_order_title: '',
                work_order_description: '',
                work_order_type: 'Maintenance',
                order_status: 'Pending',
                order_priority: 'Standard',
                assignee_id: 0,
                building_id: 0,
                building_level: 0,
                space_id: 0,
                attachments: null,
                tenant_data : null,
                property_id: 0
            },
            newOrder: newOrder,
            user_type_alias: user.userInfo ? user.userInfo.user_type_alias : '',
            selectedProperty: null,
            selectedUnitId: 0,
            invoicesActive: '',
            overviewActive: 'active'

        };

        this.levelCount = 0;
    }

    componentDidMount() {
        var self = this;
        if(this.state.orderID == 'new'){
        } else {
            workOrder.getWorkOrder(this.state.orderID, function(response) {
                if(response.data.level_count) {
                    self.levelCount = parseInt(response.data.level_count);
                }

                var selectedProperty = null;
                var selectedUnitId = 0;
                if (response.data.property) {
                    selectedProperty = {
                        details: response.data.property,
                        units: response.data.properties_units,
                        photo: response.data.property_photo
                    }
                    if (response.data.assigned_property_unit) {
                        selectedUnitId = response.data.assigned_property_unit.property_unit_id;
                    }
                }
                self.setState({
                    orderData: response.data,
                    selectedProperty: selectedProperty,
                    selectedUnitId: selectedUnitId
                })
            });
        }

        if(this.state.user_type_alias == '') {
            user.getUserDataWithCallback(function(response) {
                self.setState({
                    user_type_alias: response.data.user_data.user_type_alias
                })
            });
        }

        dropZone.setup(this, 'workorders', this.state.orderID);
    }


    componentWillUpdate(nextProps, nextState) {
    }

    // #  When uploading a new contract, the contract_id will be passed
    triggerUpload(order_id, type) {
        var self = this;
        if(order_id != 0) {
            dropZone.setup(this, 'workorders', order_id, true);
        }

        dropZone.upload(type, function() {
            if(self.state.orderID != 'new') {
                workOrder.getWorkOrder(self.state.orderID, function(response) {
                    var selectedProperty = null;
			        var selectedUnitId = 0;
                    if (response.data.property) {
                        selectedProperty = {
                            details: response.data.property,
                            units: response.data.properties_units,
                            photo: response.data.property_photo
                        }
                        if (response.data.assigned_property_unit) {
                            selectedUnitId = response.data.assigned_property_unit.property_unit_id;
                        }
                    }
                    self.setState({
                        orderData: response.data,
                        selectedProperty: selectedProperty,
				        selectedUnitId: selectedUnitId
                    })
                });
            }
        });

        const isFilesAdded = dropZone.isFilesAdded();
        if (isFilesAdded == false) {
            if (type == "new_request") {
                modal.showSuccess("Work Order Added!","This work order has been added.");
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            } else {
                modal.showInfo("There is no pending file to upload!", "warning", "top", "center");
            }
        }
    }

    handleTitleChange(e){
        this.setState({
            orderData: update(this.state.orderData, {
                work_order_title: {$set: e.target.value
                }}
            )
        });
    }

    handleOrderDescriptionChange(e) {
        this.setState({
            orderData: update(this.state.orderData, {
                work_order_description: {$set: e.target.value
                }}
            )
        });
    }

    handleOrderTypeChange(e){
        this.setState({
            orderData: update(this.state.orderData, {
                work_order_type: {$set: e.target.value
                }}
            )
        });
    }

    handleOrderStatusChange(e){
        this.setState({
            orderData: update(this.state.orderData, {
                order_status: {$set: e.target.value
                }}
            )
        });
    }

    handleOrderPriorityChange(e){
        this.setState({
            orderData: update(this.state.orderData, {
                order_priority: {$set: e.target.value
                }}
            )
        });
    }

    handleAssigneeChange(e) {
        this.setState({
            orderData: update(this.state.orderData, {
                assignee_id: {$set: e.target.value
                }}
            )
        });
    }

    handleBuildingChange(e, building_data) {
        this.levelCount = building_data ? parseInt(building_data.belongsTo.building_level_total) : 0;
        this.setState({
            orderData: update(this.state.orderData, {
                building_id: {$set: e.target.value
                }}
            )
        });
    }

    handleBuildingLevelChange(e) {
        this.setState({
            orderData: update(this.state.orderData, {
                building_level: {$set: e.target.value
                }}
            )
        });
    }

    handleSpaceChange(e) {
        this.setState({
            orderData: update(this.state.orderData, {
                space_id: {$set: e.target.value
                }}
            )
        });
    }

    handleLeasesSelect(e) {
        this.setState({
            orderData: update(this.state.orderData, {
                contract_id: {$set: e.target.value
                }}
            )
        });
    }

    handleUpdateWorkOrder(e){
        if(!this.validate()) {
            return;
        }
        var self = this;
        var data = this.state.orderData;
        data.unit_id = this.state.selectedUnitId;
        workOrder.updateWorkOrder(data, function(response) {
            workOrder.getWorkOrder(self.state.orderID, function(response) {
                var selectedProperty = null;
                var selectedUnitId = 0;
                if (response.data.property) {
                    selectedProperty = {
                        details: response.data.property,
                        units: response.data.properties_units,
                        photo: response.data.property_photo
                    }
                    if (response.data.assigned_property_unit) {
                        selectedUnitId = response.data.assigned_property_unit.property_unit_id;
                    }
                }
                self.setState({
                    orderData: response.data,
                    selectedProperty: selectedProperty,
                    selectedUnitId: selectedUnitId
                })
            });
        });
    }

    handleMarkComplete(e) {
        if(!this.validate()) {
            return;
        }
        var self = this;
        var orderData = this.state.orderData;
        orderData['mark_complete'] = true;
        workOrder.workOrderComplete(orderData, function(response) {
            workOrder.getWorkOrder(self.state.orderID, function(response) {
                var selectedProperty = null;
                var selectedUnitId = 0;
                if (response.data.property) {
                    selectedProperty = {
                        details: response.data.property,
                        units: response.data.properties_units,
                        photo: response.data.property_photo
                    }
                    if (response.data.assigned_property_unit) {
                        selectedUnitId = response.data.assigned_property_unit.property_unit_id;
                    }
                }
                self.setState({
                    orderData: response.data,
                    selectedProperty: selectedProperty,
                    selectedUnitId: selectedUnitId
                })
            });
        });
    }

    handleSaveOrder(e){
        if(!this.validate()) {
            return;
        }
        var self = this;

        var data = this.state.orderData;
        data.unit_id = this.state.selectedUnitId;

        workOrder.saveWorkOrder(data, function(order_id) {
            self.triggerUpload(order_id, "new_request");
        });
    }

    handleDeleteOrder(e){
        workOrder.deleteWorkOrder(this.state.orderData.work_order_id);
    }

    validate() {
        const orderData = this.state.orderData;
        const filesAdded = dropZone.isFilesAdded();
        const uploadSuccess = dropZone.isUploadSuccess();

        if (this.state.newOrder == false) {
            if(filesAdded == true && uploadSuccess == false) {
                modal.showInfo("You have pending files that need to be uploaded!", "warning", "top", "center");
                return false;
            }
        }
        if(orderData.work_order_description.length == 0) {
            modal.showInfo("Please supply a work order description.", "warning", "top", "center");
            return false;
        }
        if(orderData.work_order_title.length == 0) {
            modal.showInfo("Please supply a work order title.", "warning", "top", "center");
            return false;
        }

        return true;
    }

    handleGenerateRequest() {
        generatePDF.generateWorkOrderPDF(this.state.orderID, function(response) {
            modal.showInfo("PDF should begin downloading shortly.", "success", "top", "center");
        });
    }

    handlePropertyChange(e) {
        var self = this;
        var value = e.target.value;
        if (value == 0) {
            self.setState({
                orderData: update(self.state.orderData, {
                    property_id: {$set: value
                    }}
                ),
                selectedProperty: null,
                selectedUnitId: 0
            });
        } else {
            property.getProperty(value, function(response) {
                self.setState({
                    orderData: update(self.state.orderData, {
                        property_id: {$set: value
                        }}
                    ),
                    selectedProperty: response.data
                });
            });
        }
    }

    handleDeleteDocument(attachment) {
        var self = this;
        documents.deleteDocument(attachment.id, function() {
            if(self.state.orderID !== 'new') {
                var selectedProperty = null;
                var selectedUnitId = 0;
                if (response.data.property) {
                    selectedProperty = {
                        details: response.data.property,
                        units: response.data.properties_units,
                        photo: response.data.property_photo
                    }
                    if (response.data.assigned_property_unit) {
                        selectedUnitId = response.data.assigned_property_unit.property_unit_id;
                    }
                }
                self.setState({
                    orderData: response.data,
                    selectedProperty: selectedProperty,
                    selectedUnitId: selectedUnitId
                })
            }
        });
    }

    handleTabChange(type) {
        if(type == 'overview') {
            this.setState({
                overviewActive: 'active',
                invoicesActive: ''
            });
        } else if (type == 'invoices') {
            this.setState({
                overviewActive: '',
                invoicesActive: 'active'
            });
        }
    }

    selectedUnit(id) {
        this.setState({
            selectedUnitId: id
        })
    }

    renderAttachments(attachments) {
        var self = this;
        if (attachments != null) {
            if(attachments.length > 0) {
                var attachmentsLength = attachments.length
                for (var i = 0; i < attachmentsLength; i++) {
                    if (attachments[i].content_type == "pdf") {
                        var temp = attachments[i]
                        attachments.splice(i, 1);
                        attachments.push(temp)
                    }
                }
                return attachments.map((attachment, index) => (
                    <Attachment key={index} attachment={attachment} deleteFunc={self.handleDeleteDocument.bind(self)}/>
                ));
            }
        }
        else return (<div></div>);
    }

    render(){
        const orderData = this.state.orderData;
        const orderID = this.state.orderID;
        const userType = this.state.user_type_alias;
        const attachments = this.renderAttachments(orderData.attachments);
        const property_id = orderData.property_id;
        var colSize = '8';
        var isDisabled;
        var levelCount = this.levelCount;
        const selectedProperty = this.state.selectedProperty;
        const selectedUnitId = this.state.selectedUnitId;
        var units = null;
        var singleUnit = true;
        var self = this;
        const newOrder = this.state.newOrder;
        const lastUpdate = Math.ceil((moment() - moment(orderData.updated_at)) * 0.001 / 86400); //Calculate # of days
        let showInvoices = true
        let overviewActive = this.state.overviewActive;
        let invoicesActive = this.state.invoicesActive;

        if (selectedProperty != null) {
            if (selectedProperty.units_tally != 0) {
                singleUnit = false;
                units = selectedProperty.units.map((unit, index) => (
                    unit.property_unit_id == selectedUnitId ? (
                        <div class="form-group" key={index}>
                            <label for="unitname">Unit Name</label>
                            <input type="text" class="form-control selectable-unit selected-unit property-unit" value={unit.unit_name} name="unitname" disabled onClick={self.selectedUnit.bind(self, unit.property_unit_id)}/>
                        </div>
                    ) : (
                        <div class="form-group" key={index}>
                            <label for="unitname">Unit Name</label>
                            <input type="text" class="form-control selectable-unit property-unit" value={unit.unit_name} name="unitname" disabled onClick={self.selectedUnit.bind(self, unit.property_unit_id)}/>
                        </div>
                    )
                ));
            }
        }

        if(userType === 'tenant') {
            colSize = '8';
            showInvoices = false
            overviewActive = 'active'
            invoicesActive = false
        }
        if(userType === 'contractor') {
            isDisabled = 'disabled';
        }
        return (
            <div class="row blue-bottom-margin">
                <div class="row">
                    {newOrder == true ? (
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title submit-maintenance-title">Maintenance Request</span>
                        </div>
                    </div>
                    ) : (
                    <div class="sub-page-header-row col-md-11">
                        <div class="row">
                            <span class="sub-page-header-title">{orderData.work_order_title}</span>
                        </div>
                        {lastUpdate > 1 ? (
                        <div class="row">
                            <span class="sub-page-header-sub-title">Updated {lastUpdate} days ago</span>
                        </div>
                        ) : (
                        <div>
                            {lastUpdate == 1 ? (
                            <div class="row">
                                <span class="sub-page-header-sub-title">Updated 1 day ago</span>
                            </div>
                            ) : (
                            <div class="row">
                                <span class="sub-page-header-sub-title">Updated less than 1 day ago</span>
                            </div>
                            )}
                        </div>
                        )}
                        {orderData.order_status && (
                        <div class="row">
                            {orderData.order_priority && (orderData.order_priority == "High" || orderData.order_priority == "Emergency") ? (
                            <span class="sub-page-header-status">
                                <i class="fa fa-circle"></i>&nbsp; {/* TODO: Need actual icon from design */}
                                {orderData.order_status}
                            </span>
                            ) : (
                            <span class="sub-page-header-status-no-banner">
                                <i class="fa fa-circle"></i>&nbsp; {/* TODO: Need actual icon from design */}
                                {orderData.order_status}
                            </span>
                            )}
                        </div>
                        )}
                        {(orderData.order_priority && orderData.order_priority == "High") && (
                        <div class="row">
                            <span class="orange-sub-page-header-banner">
                                {orderData.order_priority}
                            </span>
                        </div>
                        )}
                        {(orderData.order_priority && orderData.order_priority == "Emergency") && (
                        <div class="row">
                            <span class="red-sub-page-header-banner">
                                {orderData.order_priority}
                            </span>
                        </div>
                        )}
                        {orderData.tenant && (
                        <div>
                            <div class="row">
                                <span class="sub-page-header-submit-title">
                                    Tenant: <NavLink style={{color: '#1a3850'}} to={'/tenant/' + orderData.tenant_id}>{orderData.tenant.tenant_firstname} {orderData.tenant.tenant_lastname}</NavLink>
                                </span>
                            </div>
                            <br/>
                        </div>
                        )}
                        {orderData.created_at && (
                        <div>
                            <div class="row">
                                <span class="sub-page-header-submit-title">
                                    Date Submitted
                                </span>
                            </div>
                            <div class="row">
                                <span class="sub-page-header-submit-date">
                                    {moment.utc(orderData.created_at).local().format('DD MMM YYYY, h:mm A')}
                                </span>
                            </div>
                        </div>
                        )}
                    </div>
                    )}
                </div>
                <TabGroup>
                    <Tab title="overview">
                        <div>
                            <div class={"col-md-" + colSize}>
                                <div class="card">
                                    <div class="header">
                                        <h4 class="title">Request Information</h4>
                                        <p class="category"></p>
                                    </div>
                                    <div class="content">
                                        <form>
                                            <input type="hidden" class="tenant_id" name="tenant_id" value="" />
                                            <div class="row">
                                                <div class="col-md-5 col-sm-6 col-xs-12">
                                                    <div class="form-group">
                                                        <label>Title*</label>
                                                        <input type="text" disabled={isDisabled} value={orderData.work_order_title} class="form-control" name="title" placeholder="Broken Disposal" id="ordertitle" onChange={this.handleTitleChange.bind(this)} />
                                                    </div>
                                                </div>
                                                <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                                    <div class="form-group">
                                                        <label for="ordertype">Request Type</label>
                                                        <div class="clearfix"></div>
                                                        <OrderTypeSelect disabled={isDisabled} columnSize={0} title="" sortID={orderData.work_order_type} onChange={this.handleOrderTypeChange.bind(this)} />
                                                    </div>
                                                </div>
                                            </div>
                                            {(userType != 'tenant' && userType != 'admin' && userType != 'property-manager') && (
                                                <div class="row">
                                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                                        <div class="form-group">
                                                            <label>Submitted On</label>
                                                            <input type="text" disabled value={moment.utc(orderData.created_at).local().format('MMMM Do YYYY, h:mm a')} class="form-control" name="submitdate" placeholder="Submit Date" id="ordercreated" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                                        <div class="form-group">
                                                            <label>Last Updated</label>
                                                            <input type="text" disabled value={moment.utc(orderData.updated_at).local().format('MMMM Do YYYY, h:mm a')} class="form-control" name="updatedate" placeholder="Update Date" id="orderupdated" />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            {orderData.completed_at && (
                                                <div class="row">
                                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                                        <div class="form-group">
                                                            <label>Completed</label>
                                                            <input type="text" disabled value={moment.utc(orderData.completed_at).local().format('MMMM Do YYYY, h:mm a')} class="form-control" name="completeddate" placeholder="Complete Date" id="ordercompleted" />
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            <div class="row">
                                                {userType != 'tenant' && (
                                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                                        <div class="form-group">
                                                            <label for="ordertype">Request Status</label>
                                                            <div class="clearfix"></div>
                                                            <OrderStatusSelect disabled={isDisabled} columnSize={0} title="" sortID={orderData.order_status} onChange={this.handleOrderStatusChange.bind(this)} />
                                                        </div>
                                                    </div>
                                                )}
                                                {userType != 'tenant' ? (
                                                    <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                                        <div class="form-group">
                                                            <label for="ordertype">Order Priority</label>
                                                            <div class="clearfix"></div>
                                                            <OrderPrioritySelect disabled={isDisabled} columnSize={0} title="" sortID={orderData.order_priority} onChange={this.handleOrderPriorityChange.bind(this)} />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div class="col-md-5 col-sm-6 col-xs-12">
                                                        <div class="form-group">
                                                            <label for="ordertype">Order Priority</label>
                                                            <div class="clearfix"></div>
                                                            <OrderPrioritySelect disabled={isDisabled} columnSize={0} title="" sortID={orderData.order_priority} onChange={this.handleOrderPriorityChange.bind(this)} />
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                            {userType != 'tenant' && (
                                                <div class="row">
                                                    {newOrder == true && (
                                                        <div class="col-md-5 col-sm-6 col-xs-12">
                                                            <div class="form-group">
                                                                <label for="ordertype">Assigned Contractor</label>
                                                                <div class="clearfix"></div>
                                                                <UsersSelect disabled={isDisabled} columnSize={0} title="" accountType="contractor" sortID={orderData.assignee_id} onChange={this.handleAssigneeChange.bind(this)} />
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label for="email">Description*</label>
                                                        <textarea rows="4" cols="80" class="form-control" placeholder="Describe the request in detail" value={orderData.work_order_description} onChange={this.handleOrderDescriptionChange.bind(this)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                {userType != 'tenant' && (
                                    <div class="col-md-12 card">
                                        <div class="card">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="header">
                                                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-house-outline"></i></span> Property</h4>
                                                        <p class="category"></p>
                                                    </div>
                                                    <div class="col-md-8 col-md-offset-2">
                                                        <div class="form-group">
                                                            <PropertiesSelect columnSize={0} sortID={property_id} title="" onChange={this.handlePropertyChange.bind(this)} />
                                                        </div>
                                                    </div>
                                                    {selectedProperty != null && (
                                                        <div class="row">
                                                            <div class="col-md-9 col-md-offset-1">
                                                                {selectedProperty.photo == null ? (
                                                                    <div class="property-photo">
                                                                        <p>No property cover image.</p>
                                                                    </div>
                                                                ) : (
                                                                    <div class="property-photo">
                                                                        <img src={selectedProperty.photo.url} width="100%" />
                                                                    </div>
                                                                )}
                                                                <div class="header">
                                                                    <h4 class="title">{selectedProperty.details.property_name}</h4>
                                                                    <p class="category">{selectedProperty.details.property_address}<br />{selectedProperty.details.property_city} {selectedProperty.details.property_state}, {selectedProperty.details.property_zip}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                    {singleUnit == false && (
                                                        <div class="row">
                                                            <div class="col-md-9 col-md-offset-1">
                                                                <p>Select a unit for this maintenance request to attach to, otherwise we will assign it to this property.</p>
                                                                {units}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {newOrder == false && (
                                <div class="col-md-4">
                                    <div class="card">
                                        <div class="header">
                                            <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-person-hard-hat"></i></span> Contractor</h4>
                                            <p class="category"></p>
                                        </div>
                                        {orderData.assigned_at != null && (
                                            <div>
                                                <div class="row">
                                                    <div class="card-section-note-title">Assigned On</div>
                                                </div>
                                                <div class="row">
                                                    <div class="card-section-note-date">{moment.utc(orderData.assigned_at).local().format('DD MMM YYYY, h:mm A')}</div>
                                                </div>
                                            </div>
                                        )}
                                        <div class="row">
                                            <div class="col-md-10 col-md-offset-1">
                                                <div class="form-group">
                                                    <label></label>
                                                    <div class="clearfix"></div>
                                                    <UsersSelect disabled={isDisabled} columnSize={0} title="" accountType="contractor" sortID={orderData.assignee_id} onChange={this.handleAssigneeChange.bind(this)} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div class="col-md-4">
                                <div class="card">
                                    <div class="header">
                                        <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-document-plus"></i></span> Attachments</h4>
                                        <p class="category">Upload relevant documents or photos</p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="content">
                                                {attachments}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="content">
                                                {this.state.dropZoneSetup !== undefined && (
                                                    <div style={{ textAlign: "center" }}>
                                                        <DropzoneComponent config={this.state.dropZoneConfig}
                                                            eventHandlers={this.state.dropZoneEventHandlers}
                                                            djsConfig={this.state.dropZoneJSConfig} />
                                                        {newOrder == false && (
                                                            <button type="button" class="btn btn-info btn-secondary btn-fill dropZone-upload" autoComplete="off" onClick={this.triggerUpload.bind(this, 0, "current")}>Upload</button>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {userType == 'contractor' && (
                                    <TenantInformationCard tenant_data={orderData.tenant_data} />
                                )}
                            </div>
                        </div>
                    </Tab>
                    {showInvoices && (
                        <Tab title="invoices">
                            {userType != 'tenant' && newOrder == false && (
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="header">
                                            <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-receipt"></i></span> Invoices</h4>
                                            <p class="category"></p>
                                        </div>
                                        <div class="row">
                                            <div class="content">
                                                <InvoiceList orderId={orderID} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Tab>
                    )}
                </TabGroup>
                <div class="row blue-bottom">
                    <div class="blue-bottom-center-align">
                        { newOrder === true ? (
                            <div class="col-md-12">
                                <button type="button" id="save-workorder" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleSaveOrder.bind(this)}>
                                Submit Request
                                </button>
                            </div>
                        ) : (
                            <div 
                                className="col-md-6 col-md-offset-3"
                                style={{display: "flex", justifyContent: "space-around"}}>
                                <button type="button" id="update-workorder" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleUpdateWorkOrder.bind(this)}>
                                    Update
                                </button>
                                <button type="button" id="generate-pdf" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleGenerateRequest.bind(this)}>
                                    Generate PDF
                                </button>
                                { userType === 'contractor' && orderData.completed_at == null && (
                                    <button type="button" id="mark-complete" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleMarkComplete.bind(this)}>
                                        Mark Complete
                                    </button>
                                )}
                                { userType !== 'contractor'  && (
                                    <button type="button" id="delete-tenant" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.handleDeleteOrder.bind(this)}>
                                        Delete
                                    </button>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/WorkOrder/WorkOrderEdit.jsx